import React from 'react';
import { Avatar, BottomNavigation, BottomNavigationAction, Box, Paper } from '@mui/material';
import { ReactFCC } from '../../interface/react';
import { pages } from '../../shared/menu';

interface FooterProps {}

const Footer: ReactFCC<FooterProps> = () => {
	const [value, setValue] = React.useState(0);

	return (
		<footer data-testid="footer-component">
			<Box sx={{ display: { xs: 'flex', md: 'none' } }}>
				<Paper sx={{ position: 'fixed', bottom: 0, left: 0, right: 0, m: { xs: 0, sm: 2 } }} elevation={3}>
					<BottomNavigation
						showLabels
						value={value}
						sx={{
							borderRadius: {
								xs: 0,
								sm: 2,
							},
						}}
						onChange={(event, newValue) => {
							setValue(newValue);
						}}
					>
						{pages.map((page) => (
							<BottomNavigationAction
								key={page.title}
								label={page.title}
								icon={
									page.icon !== 'avatar' ? (
										<page.icon />
									) : (
										<Avatar
											sx={{ width: 24, height: 24 }}
											alt="John Smith"
											src="https://mui.com/static/images/avatar/2.jpg"
										/>
									)
								}
							/>
						))}
					</BottomNavigation>
				</Paper>
			</Box>
		</footer>
	);
};

export default Footer;
